import React, { useEffect, useState } from 'react'
import { Nav, Tab } from 'react-bootstrap'
import Holdings from '../Holdings'
import NetPosition from './NetPosition';
import SmallLoader from '../../../Common/smallLoader';
import { toast } from 'react-toastify';
import { AESEncryption, ApiResDecrypt } from '../../../../CommonMethhods/CommonMethods';
import { DASHBOARD_CLIENT_DETAIL_EQUITY } from '../../../../Configuration/API_URL';
import refresh from "../../../../asset/images/refresh.svg"
import axiosInstance from '../../../../CommonMethhods/axiosInstance';

export default function HoldingNetPositionTab() {
    const [tabStatus, setTabStatus] = useState("Holdings")
    function handleTab(tab) {
        setTabStatus(tab);
    }
    const storeToken = localStorage.getItem("ssoToken");
    const [holdingData, setHoldingData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [commonError, setCommonError] = useState(false);
    const [positionData, setPostionData] = useState([])
    const [totalValue, setTotalValues] = useState({
        totalCurrent: 0,
        totalInvest: 0,
        todaysPnl: 0,
        pnl: 0,
    });
    const [smallLoaderPdf, setPdfLoader] = useState(false);
    const [smallLoaderExcel, setExcelLoader] = useState(false);

    const getHoldingTableData = async (viewType = "grid") => {
        let clientCode = "";
        if (localStorage.getItem("clientCode")) {
            clientCode = localStorage.getItem("clientCode");
        }
        if (viewType === "grid") {
            setLoader(true);
        }

        if (viewType === "pdf") {
            setPdfLoader(true);
        }
        if (viewType === "excel") {
            setExcelLoader(true);
        }
        let payloadValue = { ClientCode: clientCode, fileType: viewType };
        let encPayload = AESEncryption(payloadValue);
        try {
            const getHoldingData = await axiosInstance.post(
                DASHBOARD_CLIENT_DETAIL_EQUITY.Holdings_URL,

                `"${encPayload}"`,
            );
            const res = ApiResDecrypt(getHoldingData?.data);
            console.log("response holding", res)
            let totalCurrent=0
            let totalInvest=0
            let todaysPnl=0
            let pnl=0
            if (res?.status === 0) {
                if (viewType === "grid") {
                    setCommonError(false);
                    // setHoldingData(res?.data?.hold); //old api 
                    setHoldingData(res?.data);
                    res?.data.map((item)=>{
                        totalCurrent=totalCurrent+(item?.value)
                        totalInvest=totalInvest+(item?.invested)
                        todaysPnl=todaysPnl+(item?.todaysPnl)
                        pnl=pnl+(item?.pnl)
                    })
                    setTotalValues({
                        totalCurrent: totalCurrent,
                        totalInvest: totalInvest,
                        todaysPnl: todaysPnl,
                        pnl: pnl,
                    });
                }

                if (viewType === "excel") {
                    window.open(res?.data, "_self", "noopener,noreferrer");
                }
                if (viewType === "pdf") {
                    window.open(res?.data, "_blank", "noopener,noreferrer");
                }
            } else {
                if (viewType !== "grid") {
                    toast.error(res?.message);
                } else {
                    setHoldingData([]);
                    setCommonError(res?.message);
                }
            }
        } catch (error) {
            console.log(error);
            setCommonError(error?.message);
        } finally {
            setLoader(false);
            setExcelLoader(false);
            setPdfLoader(false);
        }
    };
    const getNetPositionTableData = async (viewType = "grid") => {
        let clientCode = "";
        if (localStorage.getItem("clientCode")) {
            clientCode = localStorage.getItem("clientCode");
        }
        if (viewType === "grid") {
            setLoader(true);
        }

        if (viewType === "pdf") {
            setPdfLoader(true);
        }
        if (viewType === "excel") {
            setExcelLoader(true);
        }
        let payloadValue = { ClientCode: clientCode, fileType: viewType };
        let encPayload = AESEncryption(payloadValue);
        try {
            const getpositionData = await axiosInstance.post(
                DASHBOARD_CLIENT_DETAIL_EQUITY.Position_URL,

                `"${encPayload}"`,
            );
            const res = ApiResDecrypt(getpositionData?.data);
            console.log("response position", res)
            if (res?.status === 0) {
                if (viewType === "grid") {
                    setCommonError(false);
                    setPostionData(res?.data)
                }

                if (viewType === "excel") {
                    window.open(res?.data, "_self", "noopener,noreferrer");
                }
                if (viewType === "pdf") {
                    window.open(res?.data, "_blank", "noopener,noreferrer");
                }
            } else {
                if (viewType !== "grid") {
                    toast.error(res?.message);
                } else {
                    setPostionData([]);
                    setCommonError(res?.message);
                }
            }
        } catch (error) {
            console.log(error);
            setCommonError(error?.message);
        } finally {
            setLoader(false);
            setExcelLoader(false);
            setPdfLoader(false);
        }
    };

    const apiCall = () => {
        if (tabStatus == "Holdings") {
            getHoldingTableData("grid");
        }
        else {
            getNetPositionTableData("grid");
        }
    }

    useEffect(() => {
        apiCall()
    }, [tabStatus]);

    const handleOnClick = (e) => {
        if (e.target.value) {
            if (tabStatus == "Holdings") {
                getHoldingTableData(e.target.value);
            }
            else {
                getNetPositionTableData(e.target.value);
            }
        }
    };
    return (
        <div className="holding-comp-card positiontab">
            <div className="card-box holdings bottom-25 ">
                <div>
                    <Tab.Container activeKey={tabStatus}>
                        {/* page tabs */}
                        <div className='holdings__title card-title d-flex justify-content-between'>
                            <Nav variant="nav tabs page-tabs">
                                <li
                                    className="nav-item"
                                    onClick={() => handleTab("Holdings")}
                                >
                                    <Nav.Link eventKey="Holdings">Holding</Nav.Link>
                                </li>
                                <li
                                    className="nav-item"
                                    onClick={() => handleTab("NetPosition")}
                                >
                                    <Nav.Link eventKey="NetPosition">Net Position</Nav.Link>
                                </li>
                            </Nav>
                            <div className="btn-wrapper-summary">
                                <img src={refresh} onClick={apiCall} style={{ cursor: "pointer" }} />
                                <button
                                    value="excel"
                                    onClick={handleOnClick}
                                    className="summary-btn excel-btn"
                                >
                                    {smallLoaderExcel ? (
                                        <div>
                                            <SmallLoader />
                                        </div>
                                    ) : (
                                        <>
                                            <span className="icon-excelsvg"></span>
                                            Excel
                                        </>
                                    )}
                                </button>
                                <button
                                    className="summary-btn pdf-btn"
                                    value="pdf"
                                    onClick={handleOnClick}
                                >
                                    {smallLoaderPdf ? (
                                        <div>
                                            <SmallLoader />
                                        </div>
                                    ) : (
                                        <>
                                            <span className="icon-pdfsvg"></span>
                                            PDF
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                        <Tab.Content>
                            {tabStatus == "Holdings" ?
                                <Holdings loader={loader} holdingData={holdingData} commonError={commonError} handleOnClick={handleOnClick} smallLoaderExcel={smallLoaderExcel} smallLoaderPdf={smallLoaderPdf} totalValue={totalValue} />
                                :
                                <NetPosition positionData={positionData} setPostionData={setPostionData} commonError={commonError} handleOnClick={handleOnClick} smallLoaderExcel={smallLoaderExcel} smallLoaderPdf={smallLoaderPdf} />
                            }
                        </Tab.Content>
                    </Tab.Container>

                </div>
            </div>
        </div>
    )
}
